export const TYPE_ASSURANCE_ID: {[key: string]: string} = {
  scolaire: '6639be14-cedb-40c4-a141-be48c0ab20af',
  retraite: '56826b3c-525b-470b-9d34-3c0f694db875',
  rcvp: '916ef13d-0d7b-48db-b586-de340650d6bd',
  voyage: 'f44e7d06-f969-11ed-be56-0242ac120002',
  rapatriement: '413eaa1b-f356-4041-a392-87667ee9479d',
};
